import { useCookieBannerAcknowledged } from '@web-platform/shared-banana-redux/src/helpers/hooks/useCookieBannerAcknowledged';
import { CONFIG_SERVICE_KEYS } from '@web-platform/shared-universal-constants-config';
import { getConfigServiceValue } from '@web-platform/shared-universal-utils-frontend/src/config';
import { isAcornRequest } from '@web-platform/shared-universal-utils-frontend/src/helpers/isAcornRequest';
import { lazyWithRetry } from '@web-platform/shared-universal-utils-frontend/src/helpers/lazyLoading';
import { getCulture } from '@web-platform/shared-universal-utils-frontend-localisation';
import { showCookieBanner } from 'saddlebag-tracking-preferences';

import { ScrollToTop } from './ScrollToTop';

const UserPreferencesDialog = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "UserPreferencesDialog" */
      './UserPreferencesDialog/UserPreferencesDialog'
    ),
);

type Props = {
  hasScrollToTop: boolean;
};

/*
These addons are currently added _inside_ each Route component. Be aware that means that on route changes they will unmount, mount, and so rerender (even if in a `memo`), as that is what React Router tells all children of a Route to do.

If you need an 'addon' to trigger only once across route changes you would need to move it higher than this - either inside the Router but not in a Route, or higher, for example in bootstrap.
*/
export const PageAddons = ({ hasScrollToTop }: Props) => {
  const cookieBannerAcknowledgedClick = useCookieBannerAcknowledged();
  const { market } = getCulture();
  const enableKetchCMP = Boolean(getConfigServiceValue(CONFIG_SERVICE_KEYS.OPS.ENABLE_KETCH_CMP));
  // When Ketch CMP is enabled, ConsentBanner must be allowed to mount in non-GDPR markets too —
  // ConsentBanner manages its own jurisdiction logic via the Ketch SDK.
  const renderUserPreferencesDialog = showCookieBanner(market) || enableKetchCMP;
  const userPreferencesProps = isAcornRequest()
    ? {}
    : {
        cookieBannerAcknowledgedClick,
      };
  return (
    <>
      {hasScrollToTop && <ScrollToTop />}
      {renderUserPreferencesDialog && <UserPreferencesDialog {...userPreferencesProps} />}
    </>
  );
};
